/* eslint-disable import/prefer-default-export */
import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
// template components
import BulletedList from '@nmx/template/dist/componentLibrary/components/BulletedList';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';

export const BulletedListStyled = styled(BulletedList)`
  padding-bottom: ${rem(16)};
  padding-left: 0;
  :last-child {
    margin-bottom: 0;
  }
  :first-child {
    margin-bottom: 0;
  }
`;

export const LinkStyled = styled(Link)`
  display: inline-block;
  padding-bottom: ${rem(16)};
`;

export const ColStyled = styled(Col)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      padding-bottom: ${mediumUp ? rem(40) : rem(32)};
    `;
  }}
`;

export const TypographyStyled = styled(Typography)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      border-bottom: ${rem(1)} solid ${theme.colors.neutral.grayDark1};
      padding-bottom: ${rem(5)};
      width: ${mediumUp ? '75%' : '100%'};
      padding-left: 0;
    `;
  }}
`;
